import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import BrandLogo from '../components/BrandLogo';
import SplitSection from '../components/SplitSection';
import { usePageTracking } from '../hooks/usePageTracking';
import performanceCandies from '../assets/newPerformanceCandy.png';
import contactImage from '../assets/newContactUs.jpeg';
import communityImage from '../assets/newCommunity.png';
import './About.css';

function About() {
  usePageTracking('about');
  const navigate = useNavigate();
  const [hoveredSide, setHoveredSide] = useState(null);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="about-page">
      <BrandLogo />
      
      {/* Back button */}
      <button className="back-button-simple" onClick={() => navigate('/')}>
        <span className="back-text">← Back</span>
        <span className="back-arrow">←</span>
      </button>

      {/* Three Split Sections - Same style as home page */}
      <div className="about-split-landing">
        <div className="split-wrapper">
          <SplitSection
            title="THE PRODUCT"
            subtitle="What Makes Us Different"
            imageSrc={performanceCandies}
            href="/the-product"
            side="left"
            buttonText="MORE ABOUT SAMBAS"
            isHovered={hoveredSide === 'left' ? true : hoveredSide === 'center' || hoveredSide === 'right' ? false : null}
            onHover={(isHovered) => setHoveredSide(isHovered ? 'left' : null)}
          />
        </div>

        <div className="split-wrapper">
          <SplitSection
            title="GET IN TOUCH"
            subtitle="We'd Love To Hear From You"
            imageSrc={contactImage}
            href="/contact"
            side="center"
            buttonText="CONTACT US"
            isHovered={hoveredSide === 'center' ? true : hoveredSide === 'left' || hoveredSide === 'right' ? false : null}
            onHover={(isHovered) => setHoveredSide(isHovered ? 'center' : null)}
          />
        </div>

        <div className="split-wrapper">
          <SplitSection
            title="COMMUNITY"
            subtitle="See What Others Are Saying"
            imageSrc={communityImage}
            href="/reviews"
            side="right"
            buttonText="REVIEWS"
            showFullImage={true}
            isHovered={hoveredSide === 'right' ? true : hoveredSide === 'left' || hoveredSide === 'center' ? false : null}
            onHover={(isHovered) => setHoveredSide(isHovered ? 'right' : null)}
          />
        </div>
      </div>
    </div>
  );
}

export default About;
